function isMailToGroupsInitialized({ state, output }) {
  if (state.get('mail.groups.form')) {
    output.true()
  } else {
    output.false()
  }
}

isMailToGroupsInitialized.outputs = ['true', 'false']
export default isMailToGroupsInitialized



// WEBPACK FOOTER //
// ./src/modules/mail/actions/isMailToGroupsInitialized.js